// Libraries
import { Flex, Skeleton, Text } from '@chakra-ui/react';
// Components
import { RatingInfoCompacted } from '@molecules/index';
// Types
import { RatingTextTooltipProps } from './RatingTextTooltip.type';

/**
 * Renders a tooltip with a rating, date, and additional information.
 *
 * @component
 * @param {RatingTextTooltipProps} props - The component props.
 * @param {Rating} props.rating  - The rating key, which should be one of the keys defined in the Rating enum.
 * @param {string} props.text - The title text for the rating.
 * @param {string} props.description - The description text for the rating.
 * @param {boolean} props.isLoading - The loading state for the rating. Default value false.
 * @returns {ReactElement} The RatingTextTooltip component.
 */
export const RatingTextTooltip = ({ rating, text, description, isLoading = false }: RatingTextTooltipProps) => {
  return (
    <Flex alignItems='center' columnGap={1}>
      <RatingInfoCompacted description={description} rating={rating} />
      <Skeleton isLoaded={!isLoading} fitContent>
        <Text lineHeight='none' variant='faded'>
          |
        </Text>
      </Skeleton>
      <Skeleton isLoaded={!isLoading} fitContent>
        <Text lineHeight='none' variant='faded'>
          {text}
        </Text>
      </Skeleton>
    </Flex>
  );
};
